/** Stable UUIDs for reproducible matrix URLs and visual baselines. */
export const FIXTURE_BLOCK_IDS = {
  navigation: 'a1000001-0001-4001-8001-000000000001',
  hero: 'a1000002-0002-4002-8002-000000000002',
  menu: 'a1000003-0003-4003-8003-000000000003',
  dynamicMenu: 'a1000005-0005-4005-8005-000000000005',
  chefStory: 'a1000006-0006-4006-8006-000000000006',
  chefStoryNotes: 'a1000086-0086-4086-8086-000000000086',
  kitchenTeam: 'a1000087-0087-4087-8087-000000000087',
  reservation: 'a1000007-0007-4007-8007-000000000007',
  reservationThirdParty: 'a1000051-0051-4051-8051-000000000051',
  reservationMessenger: 'a1000052-0052-4052-8052-000000000052',
  reservationCall: 'a1000053-0053-4053-8053-000000000053',
  tasting: 'a1000008-0008-4008-8008-000000000008',
  tastingPairing: 'a1000072-0072-4072-8072-000000000072',
  allergy: 'a1000009-0009-4009-8009-000000000009',
  heroVideo: 'a1000010-0010-4010-8010-000000000010',
  heroReel: 'a1000073-0073-4073-8073-000000000073',
  heroCounterBleed: 'a1000074-0074-4074-8074-000000000074',
  footer: 'a1000004-0004-4004-8004-000000000004',
  heroCafe: 'a1000011-0011-4011-8011-000000000011',
  heroBar: 'a1000012-0012-4012-8012-000000000012',
  heroFoodTruck: 'a1000013-0013-4013-8013-000000000013',
  navigationCafe: 'a1000014-0014-4014-8014-000000000014',
  navigationBar: 'a1000015-0015-4015-8015-000000000015',
  navigationFoodTruck: 'a1000016-0016-4016-8016-000000000016',
  sushiNavigation: 'a1000020-0020-4020-8020-000000000020',
  sushiHero: 'a1000021-0021-4021-8021-000000000021',
  sushiMenu: 'a1000022-0022-4022-8022-000000000022',
  sushiDynamicMenu: 'a1000023-0023-4023-8023-000000000023',
  sushiChef: 'a1000024-0024-4024-8024-000000000024',
  sushiReservation: 'a1000025-0025-4025-8025-000000000025',
  sushiTasting: 'a1000026-0026-4026-8026-000000000026',
  sushiAllergy: 'a1000027-0027-4027-8027-000000000027',
  sushiHeroVideo: 'a1000028-0028-4028-8028-000000000028',
  sushiFooter: 'a1000029-0029-4029-8029-000000000029',
  openingHours: 'a1000030-0030-4030-8030-000000000030',
  addressMap: 'a1000031-0031-4031-8031-000000000031',
  drinksList: 'a1000032-0032-4032-8032-000000000032',
  drinksListCellar: 'a1000070-0070-4070-8070-000000000070',
  drinksListSheet: 'a1000085-0085-4085-8085-000000000085',
  staticLocation: 'a1000033-0033-4033-8033-000000000033',
  simpleMenuStrip: 'a1000034-0034-4034-8034-000000000034',
  bakeryCounter: 'a1000035-0035-4035-8035-000000000035',
  socialFeed: 'a1000036-0036-4036-8036-000000000036',
  coffeeSubscription: 'a1000037-0037-4037-8037-000000000037',
  preOrderPickup: 'a1000038-0038-4038-8038-000000000038',
  cocktailSpotlight: 'a1000039-0039-4039-8039-000000000039',
  partyInquiry: 'a1000040-0040-4040-8040-000000000040',
  partyInquirySalon: 'a1000071-0071-4071-8071-000000000071',
  tapList: 'a1000041-0041-4041-8041-000000000041',
  vipStrip: 'a1000042-0042-4042-8042-000000000042',
  weekSchedule: 'a1000043-0043-4043-8043-000000000043',
  cateringInquiry: 'a1000044-0044-4044-8044-000000000044',
  faq: 'a1000074-0074-4074-8074-000000000074',
  faqLedger: 'a1000075-0075-4075-8075-000000000075',
  liveGps: 'a1000045-0045-4045-8045-000000000045',
  popupTicket: 'a1000046-0046-4046-8046-000000000046',
  contact: 'a1000060-0060-4060-8060-000000000060',
  contactDesk: 'a1000061-0061-4061-8061-000000000061',
  contactLedger: 'a1000062-0062-4062-8062-000000000062',
  contactThreshold: 'a1000063-0063-4063-8063-000000000063',
  backToTop: 'a1000076-0076-4076-8076-000000000076',
  backToTopPill: 'a1000077-0077-4077-8077-000000000077',
  contactChannels: 'a1000078-0078-4078-8078-000000000078',
  contactChannelsFab: 'a1000079-0079-4079-8079-000000000079',
  utilityBar: 'a1000080-0080-4080-8080-000000000080',
  utilityBarStatic: 'a1000081-0081-4081-8081-000000000081',
  utilityBarCarousel: 'a1000082-0082-4082-8082-000000000082',
  utilityBarCollapse: 'a1000083-0083-4083-8083-000000000083',
  announcementBar: 'a1000084-0084-4084-8084-000000000084',
  menuPdfCard: 'a1000047-0047-4047-8047-000000000047',
  menuCategoryGallery: 'a1000048-0048-4048-8048-000000000048',
  menuDishCards: 'a1000049-0049-4049-8049-000000000049',
  menuEditorialBoard: 'a1000050-0050-4050-8050-000000000050',
  menuStreetBoard: 'a1000054-0054-4054-8054-000000000054',
  imageGalleryMosaic: 'a1000055-0055-4055-8055-000000000055',
  imageGalleryFilmstrip: 'a1000056-0056-4056-8056-000000000056',
  imageGallerySpotlight: 'a1000057-0057-4057-8057-000000000057',
  imageGalleryLedger: 'a1000058-0058-4058-8058-000000000058',
  imageGalleryMasonry: 'a1000059-0059-4059-8059-000000000059',
} as const;
